module.exports = __webpack_public_path__ + "static/media/anewhope.256b9dfc.jpg";